<iframe
  title="Manage Notifications Screen"
  width="100%"
  height="100%"
  class="iframe-border"
  title="manageNotificationsFrame"
  [src]="urlSafe">
</iframe>
